<div  class="tw-bg-orange-90 tw-border tw-border-orange-100 tw-py-4.5 tw-px-3 tw-rounded-3 tw-mx-4 tw-mb-6 tw-relative tw-overflow-hidden"
      (click)="handleClick()"
>
  <div class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-[3px] tw-bg-[#D66736]"></div>
<div class="tw-flex tw-items-center">
  <img src="/assets/icons/orange-exclamation.png" alt="payment pending" class="tw-flex-none tw-h-8 tw-aspect-square tw-mr-2" />
  <div class="tw-mr-4.5">
    <p class="tw-font-lexend tw-font-[700] tw-text-300 tw-text-black" i18n="@@completeYourPaymentTitle">Complete your payment</p>
    <div class="tw-font-lexend tw-text-200 tw-text-gray-500">
      @if (isHairRegimen) {
        <span i18n="@@hairTreatmentKit">Hair treatment kit</span>
      } @else {
        <span i18n="@@skinTreatmentKit">Skin treatment kit</span>
      }
      <span>&nbsp;&middot;&nbsp;&#8377;{{ amount }}</span>
    </div>
  </div>
  <span class="tw-flex-none tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-semibold tw-text-200 tw-rounded-1.5 tw-py-[3px] tw-px-[9px] tw-flex tw-justify-center tw-items-center shine-button tw-relative tw-overflow-hidden tw-ml-auto"
        i18n="@@payNowButton">Pay Now</span>
</div>
</div>
